import useLocalStorageState from "use-local-storage-state";
import useCurrentUser from "./useCurrentUser";

const PINNED_COLUMNS_KEY = "pinned-columns";

const DEFAULTS = {
  transactionsClientProviderPinned: false,
  transactionsDatePinned: false,
  transactionsTotalPinned: false,
  transactionsDescriptionPinned: false,
  transactionsActionsPinned: false,
  transactionsCategoryPinned: false,
  transactionsPaymentPinned: false,
  transactionsStatusPinned: false,
  //
  latestTransactionsReportDayPinned: false,
  latestTransactionsReportIncomePinned: false,
  latestTransactionsReportExpensesPinned: false,
  latestTransactionsReportDifferencePinned: false,
  //
  monthlyReportMonthPinned: false,
  monthlyReportIncomePinned: false,
  monthlyReportExpensesPinned: false,
  monthlyReportDifferencePinned: false,

  //
  categoriesReportCategoryPinned: false,
  categoriesReportIncomePinned: false,
  categoriesReportExpensesPinned: false,
  categoriesReportDifferencePinned: false,

  //
  clientProvidersReportClientProviderPinned: false,
  clientProvidersReportIncomePinned: false,
  clientProvidersReportExpensesPinned: false,
  clientProvidersReportDifferencePinned: false,
  //
  paymentMethodsReportMethodPinned: false,
  paymentMethodsReportIncomePinned: false,
  paymentMethodsReportExpensesPinned: false,
  paymentMethodsReportDifferencePinned: false,

  //
  attachmentsDatePinned: false,
  attachmentsTypePinned: false,
  attachmentsSizePinned: false,
  attachmentsNamePinned: false,
  attachmentsActionsPinned: false,

  //
  transactionAttachmentsNamePinned: false,
  transactionAttachmentsSizePinned: false,
  transactionAttachmentsTypePinned: false,
  transactionAttachmentsActionsPinned: false,

  //
  transactionDetailsLineNumberPinned: false,
  transactionDetailsDescriptionPinned: false,
  transactionDetailsQuantityPinned: false,
  transactionDetailsUnitPricePinned: false,
  transactionDetailsSubtotalPinned: false,
  transactionDetailsActionsPinned: false,

  //
  recurringTransactionsStatusPinned: false,
  recurringTransactionsDatePinned: false,
  recurringTransactionsClientProviderPinned: false,
  recurringTransactionsDescriptionPinned: false,
  recurringTransactionsCategoryPinned: false,
  recurringTransactionsTotalPinned: false,
  recurringTransactionsActionsPinned: false,
};

export default function usePinnedColumns() {
  const { userInfo } = useCurrentUser();

  const [pinnedColumns, setPinnedColumns] = useLocalStorageState(
    `${userInfo?._id}-${PINNED_COLUMNS_KEY}`,
    { defaultValue: DEFAULTS }
  );

  const isPinnedColumn = (column: string) => {
    if ((pinnedColumns as any)?.[column]) {
      return "left";
    }

    return null;
  };

  return {
    pinnedColumns,
    updatePinnedColumns: (newState: Partial<typeof DEFAULTS>) => {
      setPinnedColumns((prev: any) => ({ ...prev, ...newState }));
    },
    isPinnedColumn,
  };
}
